import { OfficeType } from '@caresend/types';
import { ActionRequiredFilter, CurrentPastFilter, StatusFilterType } from '../../../components/specific/VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import { getStore } from '../../helpers/initStore.js';

const initialOfficeBookings = () => [...Array(15).keys()].map((index) => (`loading${index}`));
const clearAlgoliaFilters = () => ({
    actionRequiredFilter: ActionRequiredFilter.ALL,
    currentPastFilter: CurrentPastFilter.ALL,
    statusFilters: [],
    statusFilterType: StatusFilterType.ALL,
    keyData: null,
    labOrderID: null,
    loading: false,
    officeID: null,
    pages: null,
    pagesLoaded: null,
    patientID: null,
    prescriberID: null,
    specimenBagID: null,
});
const initOfficeAlgoliaOrdersFilter = () => ({
    actionRequiredFilter: ActionRequiredFilter.ACTION_REQUIRED,
    currentPastFilter: CurrentPastFilter.CURRENT,
    statusFilters: [],
    statusFilterType: StatusFilterType.ALL,
    keyData: null,
    labOrderID: null,
    loading: false,
    officeID: null,
    pages: null,
    pagesLoaded: null,
    patientID: null,
    prescriberID: null,
    specimenBagID: null,
});
const initOfficeAlgoliaState = () => ({
    orders: initOfficeAlgoliaOrdersFilter(),
});
const initOfficeLocalOrderIDs = () => ({
    [ActionRequiredFilter.ACTION_REQUIRED]: {},
    [ActionRequiredFilter.NO_ACTION_REQUIRED]: {},
    [ActionRequiredFilter.ALL]: {},
});
const initOfficeBillingSettings = () => ({
    initialized: false,
    paymentEnabled: false,
    paymentFormInitError: false,
    paymentMethodChanged: false,
    wallet: null,
    paymentMethodModalIsOpened: false,
    price: 0,
    setupCardErrorMessage: null,
    setupCardLoading: false,
    setupIntentClientSecret: null,
    saving: false,
});
const initOfficeContactSettings = () => ({
    cliaID: null,
    initialized: false,
    location: null,
    name: null,
    phoneValid: false,
    phone: null,
    saving: false,
});
const isOfficeLab = () => {
    var _a, _b;
    const store = getStore();
    return ((_b = (_a = store.state.office) === null || _a === void 0 ? void 0 : _a.office) === null || _b === void 0 ? void 0 : _b.type) === OfficeType.LAB;
};

export { clearAlgoliaFilters, initOfficeAlgoliaOrdersFilter, initOfficeAlgoliaState, initOfficeBillingSettings, initOfficeContactSettings, initOfficeLocalOrderIDs, initialOfficeBookings, isOfficeLab };
